import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './BarTender.frontend.types'

@Injectable({ providedIn: 'root' })
export class BarTender_azure_blob_storage_get_file_content_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { file_path: string, file_name: string, use_explicit_path?: boolean }): Promise<{ file_content?: Blob }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.file_path)) {
      missingRequiredInParams.push('\'file_path\'');
    }
    if (isNil(inParams.file_name)) {
      missingRequiredInParams.push('\'file_name\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/BarTender/functions/azure_blob_storage_get_file_content_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    const blobOptions: any = {
      ...options,
      observe: 'response',
      responseType: 'blob'
    };
    const response = await this.$utils.http.post<HttpResponse<Blob>>(url, body, blobOptions);
    const blobParamValue = response.status === 200 ? this.$utils.http.httpClientResponseToBlob(response) : null;
    return { file_content: blobParamValue };
    
  }

}

